export const Open_Fields = `
<h3>Open Fields Template</h3>
<hr />
<article id="open-fields">
   <div class="row">
      <div class="col-xl-3 col-lg-3 d-none d-lg-block"></div>
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-start">
         <div class="intro">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
         </div>
      </div>
      <div class="col-xl-2 col-lg-2 d-none d-lg-block"></div>
   </div>
   <div class="row">
      <div class="col-xl-3 col-lg-3 d-none d-lg-block"></div>
      <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-start">
         <div class="d-flex flex-column textarea">
            <textarea placeholder="Type your response here..." maxlength="500" id="textArea500"></textarea>
            <div class="textarea-footer d-flex justify-content-end">
               <span id="textArea500CharsRemaining">500</span>&nbsp;characters remaining
            </div>
         </div>
      </div>
      <div class="col-xl-2 col-lg-2 d-none d-lg-block"></div>
   </div>
</article>
`;
